























































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';

const cssPrefix = 'multi-reg';

@Component({
  components: {
    ...UUIFComponent,
    SwTextarea,
    SwSpinningProgress,
  },
})
export default class MultiRegModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required: true })
  validityTableData: any;
  @Prop({ required: true })
  multiRegMode : any;
  @Prop({ required: false })
  batchId : any;
  goInLoop : boolean = true;
  choiceListOpt: SelectOption[] = [];
  showSpinner : boolean = false;

  columnConfig1 : TableColumnConfig[] = [];

  tableData: TableEntry[] = [];

  closeProductDetail() {
    this.$emit('closeModal');
    this.$emit('goBackToStepOne');
  }

  confirm() {
    this.$emit('closeModal');
    this.$emit('goBackToStepOne');
  }

  created() {
    console.warn('modal created');
    if (this.multiRegMode === 'validity' || this.multiRegMode === 'registerresultWF') {
      this.tableData = [];
      console.warn(this.validityTableData);
      this.validityTableData.forEach((element: any , index : any) => {
        this.tableData.push({
          _key: index.toString(),
          serialnumber: element.serialnumber,
          status: element.status,
          message: element.message,
        });
      });
      console.warn(this.validityTableData);
    } else if (this.multiRegMode === 'registerresult') {
      console.warn(this.batchId);
      this.showSpinner = true;
      this.tableData = [];
      this.$store.commit('startLoading');
      this.callStatusApi();
    }
  }
  mounted() {
    this.defineConfig();
  }

  callStatusApi() {
    this.$store.commit('MswProductsStoreModule/mutate', { property: 'batchid', with:this.batchId  });
    this.$store.dispatch('MswProductsStoreModule/multipleRegistrationstatus', { username : this.$store.getters.getUserId })
      .then((data : any) => {
        this.$store.commit('stopLoading');
        data.arrMultiProductRegistrationStatus.forEach((element : any) => {
          if (element.batchID ===  this.batchId) {
            console.warn(element);
            this.tableData = [];
            for (let i = 0; i < element.arrAutoProductRegistrationStatus.length; i += 1) {
              this.tableData.push({
                _key: i.toString(),
                serialnumber: element.arrAutoProductRegistrationStatus[i].serialnumber,
                status: element.arrAutoProductRegistrationStatus[i].registered,
                // tslint:disable-next-line:max-line-length
                message: element.arrAutoProductRegistrationStatus[i].status === '1' ? (this.$t('products.successfullyReg')
                .toString()) : element.arrAutoProductRegistrationStatus[i].failureReason ,
              });
            }
            let flag = false;
            element.arrAutoProductRegistrationStatus.forEach((ele : any) => {
              console.warn(ele);
              if (!(ele.status === '1' || ele.registered === 'Failed')) {
                flag = true;
              }
            });
            this.showSpinner = flag ;
            console.warn(this.showSpinner);
            if (this.showSpinner) {
              setTimeout(() => {
                this.callStatusApi();
              },         3000);
            }
          }
        });
      });
  }
  getWidth(num : any) {
    console.warn(num);
    console.warn(document.getElementById('tableWidth'));
    console.warn(document.getElementById('tableWidth')!.offsetWidth);
    console.warn((num * document.getElementById('tableWidth')!.getBoundingClientRect().width) / 100);
    return (num * document.getElementById('tableWidth')!.getBoundingClientRect().width) / 100;
  }
  defineConfig() {
    this.columnConfig1 = [{
      key: 'serialnumber',
      dataKey: 'serialnumber',
      title: (this.$t('manageCase.serNum')
      .toString()),
      width: this.getWidth(20),
    },
    {
      key: 'status',
      dataKey: 'status',
      title: (this.$t('manageCase.status')
      .toString()),
      width: this.getWidth(20),
    },
    {
      key: 'message',
      dataKey: 'message',
      title: (this.$t('products.message')
      .toString()),
      width: this.getWidth(60),
      render: (createElement, data: { entry: TableEntry }) => {
      // tslint:disable-next-line:max-line-length
        return createElement('div', { domProps: { innerHTML: data.entry.message }, style : (data.entry.status === 'Valid' || data.entry.status === 'Success' || data.entry.status === 'Registered') ? 'color:green' : 'color:red' });
      },
    }];
    console.warn(this.columnConfig1);
  }

}
